module.exports = __webpack_public_path__ + "static/media/24sevenoffice_masterplan_erp_logo.4c8be0e2.png";